import React from 'react';
import { FormData } from '../App';
import { Users, Clock } from 'lucide-react';

interface Props {
  formData: FormData;
  updateFormData: (data: Partial<FormData>) => void;
}

function ManualWeeding({ formData, updateFormData }: Props) {
  const handleWeedingChange = (index: number, field: string, value: number) => {
    const newWeedingDetails = [...(formData.manualWeedingDetails || [])];
    newWeedingDetails[index] = {
      ...(newWeedingDetails[index] || {
        laborers: 1,
        costPerLaborer: 0,
        controlDuration: 0,
      }),
      [field]: value,
    };
    updateFormData({ manualWeedingDetails: newWeedingDetails });
  };

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">Manual Weeding Details</h2>
        <p className="text-gray-600 mb-6">
          Specify the details for each manual weeding operation.
        </p>
      </div>

      {Array.from({ length: formData.manualWeeding }).map((_, index) => (
        <div
          key={index}
          className="p-6 border border-gray-200 rounded-lg space-y-4 bg-gray-50"
        >
          <h3 className="text-lg font-semibold text-gray-800">
            Operation #{index + 1}
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                <Users className="w-4 h-4 inline-block mr-1" />
                Labour required / acre
              </label>
              <select
                value={formData.manualWeedingDetails[index]?.laborers || 1}
                onChange={(e) =>
                  handleWeedingChange(index, 'laborers', Number(e.target.value))
                }
                className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                required
              >
                {Array.from({ length: 10 }, (_, i) => i + 1).map((num) => (
                  <option key={num} value={num}>
                    {num}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Cost per Laborer (₹)
              </label>
              <input
                type="number"
                min="1"
                value={formData.manualWeedingDetails[index]?.costPerLaborer || ''}
                onChange={(e) =>
                  handleWeedingChange(
                    index,
                    'costPerLaborer',
                    Number(e.target.value)
                  )
                }
                className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                placeholder="Enter cost"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                <Clock className="w-4 h-4 inline-block mr-1" />
                Control Duration (days)
              </label>
              <input
                type="number"
                min="1"
                value={
                  formData.manualWeedingDetails[index]?.controlDuration || ''
                }
                onChange={(e) =>
                  handleWeedingChange(
                    index,
                    'controlDuration',
                    Number(e.target.value)
                  )
                }
                className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                placeholder="Enter duration"
                required
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default ManualWeeding;